import React, { Component } from 'react';

export default class Notifications extends Component{
    render(){
        return(
            <div className="Notifications">

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/notifications/Notifications.jsx